const statusStyles = {
  // Contact statuses
  new: 'status-new',
  viewed: 'bg-cyan-900/50 text-cyan-300 border border-cyan-700',
  responded: 'bg-green-900/50 text-green-300 border border-green-700',
  // Enquiry statuses
  contacted: 'bg-blue-900/50 text-blue-300 border border-blue-700',
  converted: 'bg-emerald-900/50 text-emerald-300 border border-emerald-700',
  // Common
  closed: 'status-closed',
};

export default function StatusBadge({ status }) {
  const style = statusStyles[status] || 'bg-gray-800 text-gray-400 border border-gray-600';
  const displayText = status?.replace('_', ' ').toUpperCase();

  return (
    <span className={`status-badge ${style}`}>
      {displayText}
    </span>
  );
}
